import {
  ArrowPathIcon,
  ClockIcon,
  DocumentTextIcon,
  QueueListIcon,
  TicketIcon,
} from "@heroicons/react/24/outline";

const icons = {
  total: TicketIcon,
  pending: ClockIcon,
  mix: QueueListIcon,
  single: DocumentTextIcon,
  recalculated: ArrowPathIcon,
};

const tones = {
  blue: "border-blue/40 bg-blue/10 text-blue-600 dark:border-blue/30 dark:bg-blue/10",
  amber:
    "border-amber-200 bg-amber-50/70 text-amber-600 dark:border-amber-900/60 dark:bg-amber-950/20",
  violet:
    "border-violet-200 bg-violet-50/70 text-violet-600 dark:border-violet-900/60 dark:bg-violet-950/20",
  green:
    "border-emerald-200 bg-emerald-50/70 text-emerald-600 dark:border-emerald-900/60 dark:bg-emerald-950/20",
  cyan: "border-cyan-200 bg-cyan-50/70 text-cyan-600 dark:border-cyan-900/60 dark:bg-cyan-950/20",
};

export default function StatCards({ items }) {
  return (
    <section
      aria-label="Voucher summary"
      className="grid grid-cols-2 gap-3 lg:grid-cols-5"
    >
      {items.map((item) => {
        const Icon = icons[item.key];
        return (
          <article
            key={item.key}
            className={`flex min-h-[82px] items-center gap-3 rounded-xl border px-4 shadow-sm ${tones[item.tone]}`}
          >
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-current/10">
              <Icon className="h-6 w-6" />
            </span>
            <div>
              <p className="text-xs font-semibold text-customInk dark:text-customHeading">
                {item.label}
              </p>
              <p className="mt-1 text-2xl font-bold leading-none text-slate-950 dark:text-white">
                {item.value}
              </p>
            </div>
          </article>
        );
      })}
    </section>
  );
}
